/**
 * 广告计划定向模块常量设置
 */

// 人群包受众冲突类型
export const AudienceConflictType = {
  IN_2_EX: 0, // 包含受众冲突了排除受众
  EX_2_IN: 1, // 排除受众冲突了包含受众
};
export const PcmDropEnum = {
  PcmDrop: 1,
  PcmNotDrop: 2,
  PcmDefault: 0,
};

export const OptimizeGoal = {
  convert: 100,
  click: 101,
  show: 102,
  reach: 103,
  videoView: 104,
  install: 105,
  inAppEvent: 106,
  lead: 107,
  fans: 108,
  webViews: 109,
  post_engagement: 110,
  valueOptimization: 111,
  liveStayTime: 113,
  productClickInLive: 114,
};

export const fakeOptimizeGoal = {
  installWithInAppEvents: 999,
};

// 优化目标对应的出价单位
export const optimizationGoalToKey = {
  [OptimizeGoal.convert]: 'adgroup_bid_conversion',
  [OptimizeGoal.install]: 'adgroup_bid_appinstall',
  [OptimizeGoal.inAppEvent]: '', // 暂不支持
  [OptimizeGoal.click]: 'adgroup_bid_click',
  [OptimizeGoal.reach]: 'adgroup_bid_impression_hint',
  [OptimizeGoal.show]: 'adgroup_bid_impression_hint',
  [OptimizeGoal.videoView]: '', // 暂不支持
  [OptimizeGoal.lead]: 'module_lead_ads_optimizal_hint',
  [OptimizeGoal.fans]: 'adgroup_bid_fans',
  [OptimizeGoal.webViews]: 'adgroup_bid_web_views',
  [OptimizeGoal.valueOptimization]: 'module_value_optimization_hint',
};
export const eventStatus = {
  ready: 1,
  insufficient: 2,
  inactive: 3,
};
// app转化事件的翻译key前缀, 与转化中台协商而来 zhaoxuebin@bytedance.com。
// app对应的转化事件都是从转化中台通过rpc接口拉取而来
export const ExternalActionI18nPrefix = 'app_rpc.external_action.';

export function translateDeepExternalAction(dea, i18n) {
  if (!dea || dea === '-') {
    return '';
  }
  return i18n.t(`${ ExternalActionI18nPrefix }${ dea }`);
}

// 浅层转化和深层转化的翻译方式一样
export const translateExternalAction = translateDeepExternalAction;

// 浅层转化事件
export const ExternalAction = {
  active: 8,
  activeRegister: 13,
  login: 114,
  createGameRole: 38,
  completeTutorial: 131,
  liveClickProduct: 167,
  initiateOrder: 267,
  shopping: 96,
  liveStayTime: 186,
};

// video view播放时长枚举，用于优化目标的计算
export const VIDEOVIEW_DURATION_TYPE = {
  NONE: 0,
  SIX_SECONDS: 1,
  TWO_SECONDS: 3,
};
// 44是SDK的广告主；49是S2S的广告主
export const SdkS2sAdvertisersIdList = [
  '44', '49',
];

export const OptimizeGoalOptions = [
  {
    label: 'adgroup_optimize_value_optimization',
    value: OptimizeGoal.valueOptimization,
    hidden: false,
    labelInfo: 'module_optimize_value_optimization_hint',
  },
  {
    label: 'adgroup_optimize_in_app_event',
    value: OptimizeGoal.inAppEvent,
    labelInfo: 'adgroup_optimize_in_app_event_info',
    hidden: false,
  },
  {
    label: 'adgroup_optimize_install',
    value: OptimizeGoal.install,
    labelInfo: 'adgroup_optimize_install_info',
    hidden: false,
  },
  {
    label: 'adgroup_optimize_install_with_in_app_event',
    value: fakeOptimizeGoal.installWithInAppEvents,
    labelInfo: 'module_optimize_install_with_in_app_event_hint',
    hidden: false,
  },
  {
    label: 'adgroup_optimize_conversion',
    labelInfo: 'adgroup_optimize_conversion_info',
    value: OptimizeGoal.convert,
    hidden: false,
  },
  {
    label: 'adgroup_optimize_click',
    labelInfo: 'adgroup_optimize_click_info',
    value: OptimizeGoal.click,
    hidden: false,
  },
  {
    label: 'adgroup_optimize_impression',
    value: OptimizeGoal.show,
    hidden: false,
  },
  {
    label: 'adgroup_optimize_lead',
    value: OptimizeGoal.lead,
    hidden: false,
  },
  {
    label: 'adgroup_optimize_fans',
    value: OptimizeGoal.fans,
    hidden: false,
  },
  {
    label: 'adgroup_optimize_web_views',
    value: OptimizeGoal.webViews,
    hidden: false,
  },
  {
    label: 'adgroup_optimize_reach',
    value: OptimizeGoal.reach,
    hidden: false,
  },
  {
    label: 'module_adgroup_optimize_videoview_6s', // videoview 6s
    value: `${ OptimizeGoal.videoView }_${ VIDEOVIEW_DURATION_TYPE.SIX_SECONDS }`,
    hidden: false,
  },
  {
    label: 'module_adgroup_optimize_videoview_2s', // videoview 2s
    value: `${ OptimizeGoal.videoView }_${ VIDEOVIEW_DURATION_TYPE.TWO_SECONDS }`,
    hidden: false,
  },
  {
    label: 'adgroup_optimize_post_engagement',
    value: OptimizeGoal.post_engagement,
    hidden: false,
  },
];
export const brandOptimizeGoalOptions = [
  {
    label: 'adgroup_optimize_reach',
    value: OptimizeGoal.reach,
    hidden: false,
  },
  {
    label: 'module_adgroup_optimize_videoview_6s', // videoview 6s
    value: `${ OptimizeGoal.videoView }_${ VIDEOVIEW_DURATION_TYPE.SIX_SECONDS }`,
    hidden: false,
  },
  {
    label: 'module_adgroup_optimize_videoview_2s', // videoview 2s
    value: `${ OptimizeGoal.videoView }_${ VIDEOVIEW_DURATION_TYPE.TWO_SECONDS }`,
    hidden: false,
  },
];
// 国际化的计费方式
// export const pricingType = {
//   OCPC: 7,
//   CPC: 2,
//   CPV: 10,
//   CPM: 1,
//   OCPM: 9, // 目前不支持
// };

export const BrandSafetyMap = {
  UN_SAFE: 1,
  SAFE: 2,
  HOT: 3,
  FLAGSHIP: 4,
  STANDARD_INVENTORY: 5,
  SELECTED_INVENTORY: 6,
};
export const neccssaryParams = ['pricing_type', 'currency_code', 'objective_type', 'classify', 'budget', 'country'];


export const BrandSafetyFilterMap = {
  INVENTORY_FILTER: 1,
  THIRDPARTY_FILTER: 2,
};

export const offlineCountryTipsMap = {
  SHOP: {
    EDIT: {
      message: 'module_adgroup_shop_offline_edit_hint',
    },
    CREATE: {
      message: 'module_adgroup_shop_offline_create_hint',
      target: 'vi-store',
      ctaText: 'module_adgroup_shop_offline_create_cta',
    },
  },
  CATALOG: {
    EDIT: {
      message: 'module_adgroup_catalog_offline_edit_hint',
    },
    CREATE: {
      message: 'module_adgroup_catalog_offline_create_hint',
      target: 'product_platform_id',
      ctaText: 'module_adgroup_catalog_offline_create_cta',
    },
  },
};
